export const YOUNG_ADULT_PROMOTION_NAME = 'TSA PreCheck® $20 Take Off'
